<style scoped  lang="less">
@import "detailsStandings.less"; // 引入公共LESS文件
</style>
<template>
  <div>
    <div class="data-loading" style="padding:20vh 0 50vh 0;" v-if="loading">
      <van-loading vertical
        ><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading
      >
    </div>
    <div v-if="!loading && league && match && matchId" class="stadingsWarp">
      <div class="flex flex-pack-justify flex-align-center">
        <div class="subset">
          <template v-for="item in tabs">
            <a
              :key="item.value"
              :class="tab == item.value ? 'on' : ''"
              v-if="
                standingsList.reduce((t, v) => t + v[item.value].length, 0) &&
                !singleTab
              "
              @click="tabChange(item.value)"
            >
              {{ item.label }}
            </a>
          </template>
        </div>
        <div class="dot-tips" v-if="playing.length && match.state != 4">
          {{ langConfig.details[langConfig.curLang]['STANDING']['LIVE_STANDING'] }}
        </div>
      </div>
      <!-- 数据内容 -->
      <div class="standings">
        <div class="table-filter">
          <span
            :class="mobileShow == 'full' ? 'active' : ''"
            @click="filterChange('full')"
          >
            {{ langConfig.details[langConfig.curLang]['STANDING']['FULL'] }}
          </span>
          <span
            :class="mobileShow == 'form' ? 'active' : ''"
            @click="filterChange('form')"
          >
          {{ langConfig.details[langConfig.curLang]['STANDING']['FORM'] }}
          </span>
        </div>
        <div class="tableWarp">
          <table
            class="tableList"
            :class="mobileShow == 'full' ? 'full' : 'form'"
            v-for="group in standingsList"
            :key="group.name"
          >
            <thead>
              <tr>
                <th width="30">#</th>
                <template v-for="(item, index) in tableHead">
                  <th
                    :key="index"
                    :class="[
                      item == 'W/P/L' ? item.replace(/\//g, '') : item,
                      item == langConfig.details[langConfig.curLang]['STANDING']['TABLE_HEAD'][0] || item == ''
                        ? ''
                        : ['', langConfig.details[langConfig.curLang]['STANDING']['TABLE_HEAD'][9]].includes(item)
                        ? 'form'
                        : 'full',
                    ]"
                    v-if="1"
                  >
                    {{ index == 0 && group.name ? group.name : item }}
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in group[tab]">
                <tr :key="index" v-if="1">
                  <td>
                    <div
                      class="relegation"
                      :style="
                        item.gradeId
                          ? {
                              backgroundColor: grade.find(
                                (gradeItem) => gradeItem.id == item.gradeId
                              )['color'],
                            }
                          : {}
                      "
                    >
                      {{ index + 1 }}
                    </div>
                  </td>
                  <td class="">
                    <span
                      :class="[
                        item.team.id == match.homeTeam.id ||
                        item.team.id == match.awayTeam.id
                          ? 'sign'
                          : '',
                      ]"
                      >{{ item.team.shortName || item.team.fullName }}</span
                    >
                  </td>
                  <td class="">
                    <div
                      class="dot"
                      v-if="item.isPlaying && match.state != 4"
                    ></div>
                  </td>
                  <td class="full">{{ item.matches || 0 }}</td>
                  <td class="full">{{ item.win || 0 }}</td>
                  <td class="full">{{ item.draw || 0 }}</td>
                  <td class="full">{{ item.loss || 0 }}</td>
                  <td class="full">{{ item.gf || 0 }}/{{ item.ga || 0 }}</td>
                  <td class="full">{{ item.winDiff || 0 }}</td>
                  <td class="full">{{ item.pts || 0 }}</td>
                  <td class="form" style="white-space: nowrap">
                    <div
                      class="record"
                      :class="'record_' + ['', 'w', '', 'l', '', 'd'][result]"
                      v-for="(result, index) in item.recentFiveResult"
                      :key="index"
                    >
                      <!-- {{ ["", "W", "", "L", "", "D"][result] }} -->
                      {{ langConfig.details[langConfig.curLang]['H2H']['RESULT_ARR'][result] }} 
                      <div class="popoverbox">
                        <div class="time flex">
                          {{
                            common.dateStr(
                              item.recentFive[index]["startTime"],
                              "dd/MM/YYYY HH:mm"
                            )
                          }}
                        </div>
                        <div class="flex flex-pack-justify">
                          <div class="teamName home">
                            {{ item.recentFive[index].homeTeam.fullName }}
                          </div>
                          <div>
                            {{
                              item.recentFive[index].homeLive.scoreFull || 0
                            }}:{{
                              item.recentFive[index].awayLive.scoreFull || 0
                            }}
                          </div>
                          <div class="teamName away">
                            {{ item.recentFive[index].awayTeam.fullName }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </template>
              <tr v-show="!group[tab].length">
                <td :colspan="tableHead.length + 1">
                  <div class="no-data">
                    <img src="../../../assets/images/icon-nodata.png" alt="" />
                    <span>{{ langConfig.txtLang[langConfig.curLang]['NO_DATA'] }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 标识 -->
        <ul class="relegationList flex">
          <li
            class="flex flex-align-center"
            v-for="item in grade"
            :key="item.id"
          >
            <div class="drop" :style="{ backgroundColor: item.color }"></div>
            <div class="name">{{ item.name }}</div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="!loading && !league && !match && !matchId"><DefaultPic /></div>
  </div>
</template>

<script>
import DefaultPic from "@/components/defaultPic";
import { getMatchStadings } from "@/api/api";
export default {
  components: {
    DefaultPic,
  },
  data() {
    return {
      isReadTime:0,
      loading: true,
      baseParam: {
        userToken: "",
      },
      playing: [],
      data: null,
      singleTab: false,
      mobileShow: "full",
      tableHead: this.langConfig.details[this.langConfig.curLang]['STANDING']['TABLE_HEAD'],
      tab: "all",
      tabs: [
        { label: this.langConfig.details[this.langConfig.curLang]['STANDING']['ALL'], value: "all" },
        { label: this.langConfig.details[this.langConfig.curLang]['STANDING']['HOME'], value: "home" },
        { label: this.langConfig.details[this.langConfig.curLang]['STANDING']['AWAY'], value: "away" },
      ],
      grade: [],
      standingsList: [
        {
          all: [],
          home: [],
          away: [],
        },
      ],
    };
  },
  methods: {
    logdingFlag() {
      if (typeof window != "undefined" && this.loading) {
        return true;
      }
      return false;
    },
    //数据读取
    async getMatchStadingsData() {
      let obj = {
        matchId: this.matchId,
      };
      var _this = this;
      let param = Object.assign(obj, this.baseParam);
      await getMatchStadings(param)
        .then((res) => {
          this.loading = false;
          let data = JSON.parse(JSON.stringify(res.data));
          //console.log("getMatchStadingsData", data);
          this.dataFormat(data);
        })
        .catch((res) => {
          console.error(res);
        });
    },
    dataFormat(data) {
      if (data) {
        const playing = (data?.["playing"] || []).map((item) => item.id);
        const grade = data["standing"]?.["grade"] || [];
        const _group = data["standing"]?.["group"] || [];
        const group = new Array(_group.length || 1).fill("").map((item) => ({
          name: "",
          all: [],
          home: [],
          away: [],
        }));
        if (group.length > 1) {
          // 有分组赛
          _group.forEach((gradeItem, index) => {
            group[index].name = gradeItem.name;
            group[index].all = gradeItem["allStandings"] || [];
            group[index].home = gradeItem["homeStandings"] || [];
            group[index].away = gradeItem["awayStandings"] || [];
          });
        } else {
          group[0].all = _group?.[0]?.["allStandings"] || [];
          group[0].home = _group?.[0]?.["homeStandings"] || [];
          group[0].away = _group?.[0]?.["awayStandings"] || [];
        }
        this.playing = playing;
        this.grade = grade;
        this.standingsList = group;

        let allLength = 0;
        let homeLength = 0;
        let awayLength = 0;
        group.forEach((item) => {
          allLength += item.all.length;
          homeLength += item.home.length;
          awayLength += item.away.length;
        });
        this.singleTab =
          (allLength && !homeLength && !awayLength) ||
          (!allLength && homeLength && !awayLength) ||
          (!allLength && !homeLength && awayLength);
      }
    },
    tabChange(value) {
      this.tab = value;
    },
    filterChange(type) {
      this.mobileShow = type;
    },
    init() {
      if (!this.matchId) {
        return;
      }
      this.getMatchStadingsData();
    },
  },
  created() {
    this.init();
    this.isReadTime=this.isRead;
  },
  watch: {
    isRead(val){
      if(val!=this.isReadTime){
        this.init();
        console.log('积分版-数据重置');
        this.isReadTime=val;
      }
    },
    matchId() {
      this.init();
    },
    socketStandingsList(val) {
      this.dataFormat(JSON.parse(JSON.stringify(val)));
      //console.log("实时积分更新", JSON.stringify(val));
      this.$forceUpdate();
    },
  },
  mounted() {},
  beforeDestroy() {},
  props: {
    //联赛信息
    league: {
      type: Object,
      default: null,
    },
    //比赛信息
    match: {
      type: Object,
      default: null,
    },
    //socket推送
    socketStandingsList: {
      type: Object,
      default: () => {},
    },
    //比赛ID
    matchId: {
      type: Number,
      default: null,
    },
    isRead: {
      type: Number,
      default: 0,
    },
    
  },
};
</script>



// WEBPACK FOOTER //
// ./src/views/details/components/detailsStandings.vue